import { BaseCol } from "@app/components/common/BaseCol/BaseCol";
import { BaseImage } from "@app/components/common/BaseImage/BaseImage";
import { Breadcrumb } from "antd";
import styled from "styled-components";

export const HomeWrapper = styled.div`
    display: flex;
    align-items: center;
    margin-left: 1rem;
`;

export const HomeIconWrapper = styled(BaseImage)`
    width: 1.5rem;
`;

export const HomeTitleWrapper = styled.div`
    font-family: 'Onest';
    font-weight: 700;
    margin-left: 0.5rem;
`;

export const BreadcrumbItem = styled(Breadcrumb.Item)`
    font-weight: 400;
    margin-left: 0.5rem;
    color: #000;
    line-height: 0.7rem;
`;

export const BreadcrumbSeparator = styled(BaseCol)`
    margin-left: 0.5rem;
`;

export const BreadcrumbItemWrapper = styled.div`
    margin-left: 0.5rem;
    vertical-align: middle;

    img {
        width: 1.5rem;
        display: inline-block;
    }
    span {
        font-family: 'Onest';
        font-weight: 700;
        margin-left: 0.2rem;
        line-height: 0.7rem;
        margin-top: 0.6rem;
        color: #000;
        display: inline-block;
    }
`;